<template>
  <main class="content">
      <div class="row">
          <h1>
              Add new Featured video
          </h1>
      </div>
      <form novalidate v-on:submit.prevent="addFeatured" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

          <fieldset class="form--item">
              <label class="label" for="">
                  Youtube or Vimeo Link:
              </label>
              <div class="input_text" id="link">
                  <input name="" required v-model="featured.link" placeholder="Paste a URL link from a Youtube or Vimeo video" type="text" value=""/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Partner:
              </label>
              <div class="input_text" id="partnerId">
                  <v-select v-model="featured.partnerId" required :searchable="false" placeholder="Pick a partner" :options="partners"></v-select>
              </div>
          </fieldset>
          <div class="row">
              <button class="btn btn_blue" type="submit">
                  Add featured video
              </button>
          </div>
      </form>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import vSelect from "vue-select"
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as CreateResource from '../../mixins/createResource.mixin';

export default {
  name: 'AddFeatured',
  components: {vSelect, Message, Loading},
  mixins:[ValidateForm, CreateResource],
  data () {
    return {
      featured: {
        partnerId: ''
      },
      resource: 'featured',
      parentResource: 'Featured',
      partners: [],
      required_fields: [
        {'attribute': 'featured.link', 'message': 'Video link is missing', 'id': 'link'},
        {'attribute': 'featured.partnerId', 'message': 'partnerId is missing', 'id': 'partnerId'}
      ],
    }
  },
  created(){
    var self = this;
    HttpService.index('partners', {
        /*stripeAccountLinked: true*/
    }, function(response, error){
      self.partners = response.result.data;
      self.partners = self.partners.map(item => {
        return {value: item.id, label: item.name}
      });
    });
  },
  methods: {
    addFeatured(){
      let featured = {
        link: this.featured.link,
        partnerId: this.featured.partnerId.value || this.featured.partnerId
      }
      this.createResource(featured);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AddFeatured.vue?7514c932